import React, { ChangeEvent, FormEvent, KeyboardEvent, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Icon from '_components/icon';

import { useChat } from '_modules/chat/hooks/useChat';
import { useChatContext } from '_modules/chat/hooks/useContext';
import { MAX_QUESTION_CHARS } from '_modules/chat/utils';

import {
  StyledFooter,
  StyledForm,
  StyledNotice,
  StyledNoticeLink,
  StyledSend,
  StyledTextarea,
} from './style';

const PanelFooter = () => {
  const { t } = useTranslation('chat');
  const { state } = useChatContext();
  const { send } = useChat();
  const [value, setValue] = useState('');

  const isTooLong = value.length > MAX_QUESTION_CHARS;
  const isEmpty = !value.trim();

  const submit = () => {
    if (isEmpty || isTooLong) return;

    setValue('');
    void send(value);
  };

  const onChange = (event: ChangeEvent<HTMLTextAreaElement>) =>
    setValue(event.target.value);

  const onKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key !== 'Enter' || event.shiftKey) return;

    event.preventDefault();
    submit();
  };

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    submit();
  };

  return (
    <StyledFooter>
      <StyledForm onSubmit={onSubmit}>
        <StyledTextarea
          $hasError={isTooLong}
          autoFocus
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={t('field.placeholder')}
          value={value}
        />
        <StyledSend
          aria-label={t('field.send')}
          disabled={isEmpty || isTooLong}
          type="submit"
        >
          <Icon color="white" glyph="send" size={16} />
        </StyledSend>
      </StyledForm>
      {!!state.config.manualUrl && (
        <StyledNotice>
          <Trans
            components={{
              lien: (
                <StyledNoticeLink
                  href={state.config.manualUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                />
              ),
            }}
            i18nKey="notice"
            ns="chat"
          />
        </StyledNotice>
      )}
    </StyledFooter>
  );
};

export default PanelFooter;
